/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Categorized operating system type
 * @export
 */
export const ControlOperatingSystemCategory = {
    Windows: 'Windows',
    WindowsServer: 'Windows Server',
    MacOs: 'macOS',
    Linux: 'Linux',
    IOs: 'iOS',
    Android: 'Android',
    ChromeOs: 'ChromeOS',
    NetworkDevice: 'Network Device',
    Other: 'Other'
} as const;
export type ControlOperatingSystemCategory = typeof ControlOperatingSystemCategory[keyof typeof ControlOperatingSystemCategory];


export function ControlOperatingSystemCategoryFromJSON(json: any): ControlOperatingSystemCategory {
    return ControlOperatingSystemCategoryFromJSONTyped(json, false);
}

export function ControlOperatingSystemCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlOperatingSystemCategory {
    return json as ControlOperatingSystemCategory;
}

export function ControlOperatingSystemCategoryToJSON(value?: ControlOperatingSystemCategory | null): any {
    return value as any;
}

